import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import { SIDEBAR_WIDTH } from '@/components/NewSidebar';
import anonymous from '@/images/anonymous.svg';
import { useAuth } from '@/services/auth';
import styled from '@emotion/styled';
import { ButtonBase } from '@mui/material';
import { useState } from 'react';
import { ProfilePopup } from '../../../ProfilePopup';

const StyledProfileButton = styled(ButtonBase)`
    padding: 0 16px;
    height: 56px;
    display: flex;
    border-radius: 12px;
    width: 100%;
    justify-content: start;
    gap: 12px;

    :hover {
        background-color: ${({ theme }) => theme.colors.black[100]};
        color: ${({ theme }) => theme.colors.secondary[900]};
    }
`;

const Image = styled.img`
    width: 24px;
    height: 24px;
    border-radius: 50%;
`;

const StyledMaskedIcon = styled(MaskedIcon)`
    color: ${({ theme }) => theme.colors.secondary[700]};
`;

const ProfileInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    font-size: 16px;

    color: ${({ theme }) => theme.colors.secondary[900]};
`;

const PositionedProfilePopup = styled(ProfilePopup)`
    bottom: 34px;
`;

export const Profile = () => {
    const { user, isAnonymous } = useAuth();
    const [isOpen, toggleOpen] = useState(false);
    const profileName = isAnonymous ? 'Guest' : `${user?.given_name ?? ''} ${user?.family_name ?? ''}`;

    const closePopup = () => toggleOpen(false);

    return (
        <>
            <StyledProfileButton id="profile_data" onClick={() => toggleOpen(!isOpen)}>
                {user?.picture ? <Image src={user.picture} /> : <StyledMaskedIcon src={anonymous} size="24px" />}
                <ProfileInfo>{profileName}</ProfileInfo>
            </StyledProfileButton>
            <PositionedProfilePopup isOpen={isOpen} left={SIDEBAR_WIDTH} onOutsideClick={closePopup} closePopup={closePopup} />
        </>
    );
};
